export default "__VITE_ASSET__DHAgPiUO__"